import { getPublic } from "../../data/api";
export async function getSettings() {
    return await getPublic('public/settings')
}
